export default __webpack_public_path__ + "static/media/plain-sticker-R.db7957de.png";